<template>
  <el-dialog
    :title="model.id > 0 ? '编辑零件' : '新增零件'"
    :visible.sync="visible"
    width="750px"
    @close="$emit('update:show', false)"
    @open="opened"
    :close-on-click-modal="false"
  >
    <el-form
      size="small"
      ref="form"
      label-width="100px"
      class="mt-20"
      :model="model"
      :rules="formRules"
    >
      <el-form-item label="零件名称" prop="name">
        <el-input v-model="model.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="供应商" prop="supplier_id" v-if="showSupplier">
        <el-select
          v-model="model.supplier_id"
          filterable
          placeholder="请选择"
          style="width: 100%"
        >
          <el-option
            v-for="item in suppliers"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="分类">
        <el-select
          v-model="model.item_category_id"
          filterable
          placeholder="请选择"
          style="width: 100%"
        >
          <el-option
            v-for="item in categories"
            :key="item.id"
            :label="item.whole_name.replace(/,/g, '-')"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="机型" prop="machine_type">
        <el-select
          v-model="model.machine_type"
          multiple
          filterable
          remote
          reserve-keyword
          placeholder="请输入关键词搜索"
          :remote-method="searchMachineTypeOptions"
          :loading="loading"
          style="width: 100%"
        >
          <el-option
            v-for="(item, index) in options"
            :key="item + index"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
        <!-- <el-input v-model="model.machine_type" autocomplete="off"></el-input> -->
      </el-form-item>
      <el-form-item label="件号" prop="part_number">
        <el-input v-model="model.part_number" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="描述" prop="description">
        <el-input
          v-model="model.description"
          autocomplete="off"
          type="textarea"
        ></el-input>
      </el-form-item>
      <el-form-item label="零件包">
        <el-checkbox v-model="model.package"></el-checkbox>
      </el-form-item>
      <el-form-item class="list" label="零件明细" v-if="model.package">
        <el-table
          v-if="model.items.length > 0"
          :data="model.items"
          header-row-class-name="customer-mini-header"
        >
          <el-table-column
            prop="name"
            label="名称"
            min-width="120"
          ></el-table-column>
          <el-table-column
            prop="part_number"
            align="center"
            label="件号"
            min-width="120"
          ></el-table-column>
          <el-table-column prop="price" align="center" label="定价">
            <template slot-scope="scope">{{
              scope.row.price.toFixed(2)
            }}</template>
          </el-table-column>
          <el-table-column align="center" label="数量">
            <template slot-scope="scope">
              <el-input-number
                size="mini"
                v-model="scope.row.count"
                :min="1"
                :max="1000"
                label
                @change="changePartPrice()"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column width="50">
            <template slot-scope="scope">
              <el-button
                type="text"
                class="text-danger"
                @click="removeItem(scope.$index)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-button
          size="small"
          icon="el-icon-plus"
          type="primary"
          @click="itemSelectorVisible = true"
          >添加</el-button
        >
      </el-form-item>
      <el-form-item label="成本价" prop="price">
        <el-input-number
          v-model="model.cost_price.price"
          :precision="2"
          :min="0"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="定价" prop="price">
        <el-input-number
          v-model="model.price"
          :precision="2"
          :min="0"
        ></el-input-number>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="submiting"
        @click="submitForm"
        >确 定</el-button
      >
    </span>
    <item-selector
      :show.sync="itemSelectorVisible"
      :selection="model.items"
      :inner="true"
      @selected="doneSelectedItems"
    ></item-selector>
  </el-dialog>
</template>

<script>
import {
  createCustomerInvoice,
  updateCustomerInvoice,
  itemCategoryList,
  supplierList,
  itemList,
  createItem,
  updateItem,
  itemDetail,
} from '../service/getData'
import ItemSelector from '@/components/item_selector'
import { numberMul } from '@/util/index'
import { parse } from 'semver'
import { clone } from '../util'

export default {
  components: { ItemSelector },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
    showSupplier: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
    model() {},
  },
  data() {
    return {
      itemSelectorVisible: false,
      visible: this.show,
      options: [],
      loading: false,
      formRules: {
        name: [
          { required: true, message: '请输入零件名称', trigger: 'blur' },
          {
            min: 1,
            max: 100,
            message: '长度在 1 到 100 个字符',
            trigger: 'blur',
          },
        ],
      },
      submiting: false,
      categories: [],
      suppliers: [],
    }
  },
  created() {
    this.requestItemCategories()
    if (this.showSupplier) {
      this.requestSuppliers()
    }
  },
  methods: {
    async requestItemCategories() {
      let res = await itemCategoryList({ page: 0, size: 1000, category: 1 })
      if (res.code == 0) {
        this.categories = res.data.list
      }
    },
    async requestSuppliers() {
      let res = await supplierList({ page: 0, size: 1000 })
      if (res.code == 0) {
        this.suppliers = res.data.list
      }
    },
    async requestItems() {
      let res = await itemList({ page: 0, size: 1000 })
      if (res.code == 0) {
        this.categories = res.data.list
      }
    },
    async searchMachineTypeOptions(query) {
      if (!query) {
        this.options = []
        return
      }
      let res = await itemCategoryList({
        page: 0,
        size: 1000,
        category: 2,
        query: query,
      })
      this.options = res.data.list.map((item) => {
        return item.name
      })
    },
    doneSelectedItems(items) {
      this.model.items = this.model.items.concat(items)
      this.model.items.map((v) => {
        delete v.count
        this.$set(v, 'count', 1)
      })
      this.changePartPrice()
    },
    removeItem(index) {
      this.model.items.splice(index, 1)
      this.changePartPrice()
    },
    changePartPrice() {
      var price = 0
      this.model.items.map((item) => {
        price += numberMul(item.price, item.count)
      })
      this.model.price = price
    },
    async opened() {
      if (this.model.package == 1) {
        let res = await itemDetail(this.model.id)
        this.model.items = res.data.items
      }
      this.model.item_category_id =
        this.model.item_category_id == 0 ? '' : this.model.item_category_id
      if (this.model.dealer) {
        this.model.supplier_id =
          this.model.supplier_id == 0 ? '' : this.model.supplier_id
      }
    },
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submiting = true
          let data = clone(this.model)
          data.item_category_id = parseInt(data.item_category_id) || 0
          if (data.dealer) {
            data.supplier_id = parseInt(data.supplier_id) || 0
          }
          data.package = data.package ? 1 : 0
          data.items = data.items.map((item) => {
            return { item_id: item.id, count: parseInt(item.count) }
          })

          data.machine_type = data.machine_type.join(',')

          if (data.id > 0) {
            let res = await updateItem(data)
            if (res.code == 0) {
              this.$emit('updated', res.data)
              this.visible = false
            }
          } else {
            let res = await createItem(data)
            if (res.code == 0) {
              this.$emit('created', res.data)
              this.visible = false
            }
          }
          this.submiting = false
        } else {
          this.submiting = false
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>

<style scoped>
.customer-header th {
  padding: 0 !important;
}
.el-input-number--mini {
  width: 100px !important;
}
</style>